import { useNavigate, useParams } from "react-router-dom";
import { EntityIcon } from "@/components/ui/cores";
import { PageHeader } from "@/components/ui/page-header";
import { Column, DataTable, Pagination } from "@/components/datatable/DataTable";
import Filter from "@/components/datatable/Filter";
import { ActionButton, Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { UsuarioService } from "@/services";
import { PageRequest, PaginationData } from "@/types/pagination";
import { Sort } from "@/types/sort";
import { Usuario } from "@/types/usuario";
import { AxiosError } from "axios";
import { Eye, Mail, Plus, ShieldCheck } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { ErrorPage } from "../ErrorPage";
import useAuth from "@/components/hooks/use.auth";
import { podeAlterarSenha, temPermissao } from "@/utils/permissao";

type UsuarioListProps = {
    
}

export const UsuarioListPage = (props: UsuarioListProps) => {
  const [data, setData] = useState<Usuario[]>([]);
  const [pagination, setPagination] = useState<PaginationData>();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<AxiosError>();
  const auth = useAuth();
  const { tenant } = useParams();
  const navigate = useNavigate();
  const podeAlterar = temPermissao(auth.user, tenant, 'USUARIO_WRITE');
  
  const columns: Column[] = [
    {field: 'id', show: false, label: 'ID'},
    {field: 'nome', show: true, label: 'Nome', filter: true},
    {field: 'email', show: true, label: 'Email', filter: true}, 
  ]

  const onSearch = (filterRsql?: string, pagination?: PageRequest, sort?: Sort) => {
    setLoading(true);
    UsuarioService.find(filterRsql, pagination, sort)
      .then(response => {
        setData(response.data.content)
        setPagination({
          ...response.data
        })
      })
      .catch(setError)
      .finally(() => setLoading(false));
  }

  const solicitarNovaSenha = (usuario: Usuario) => {
    var idLoading = toast.loading(`Processando solicitação de nova senha para o usuário ${usuario.nome}`);
    UsuarioService.solicitarNovaSenha(usuario.id!)
      .then(() => toast.info(`Enviamos para ${usuario.email} o link para definir uma nova senha.`))
      .catch(() => {})
      .finally(() => toast.dismiss(idLoading));
  }

  if (error){
    return <ErrorPage axiosError={error} />
  }

  return (
    <div className="space-y-4">
    <PageHeader icon={<EntityIcon entidade="usuario" />} title="Usuários" total={pagination?.totalElements}>
      {podeAlterar && <Button onClick={() => navigate('novo')}><Plus className="mr-2 h-4 w-4" /> Novo usuário</Button>}
    </PageHeader>
    <Card className="overflow-hidden shadow-none">
      <Filter columns={columns} onSearch={onSearch} defaultSort={{sort: 'nome,asc'}} loading={loading} />
      <DataTable loading={loading}
        values={data} 
        columns={columns} 
        keyExtractor={(item: Usuario, index: number) => item.id!} 
        pagination={pagination}
        actions={(item: Usuario) => {
          return (
            <>
            <ActionButton onClick={() => navigate(item.id!)} icon={podeAlterar ? <ShieldCheck className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />} label={podeAlterar ? "Editar e permissões" : "Visualizar"} />
            {podeAlterarSenha(auth.user, tenant, item.id) && (
              <ActionButton onClick={() => solicitarNovaSenha(item)} icon={<Mail className="h-3.5 w-3.5" />} label="Enviar e-mail para troca de senha" />
            )}
            </>
          )
        }}
      />
      <Pagination pagination={pagination} />
    </Card>
    </div>
  )
}